import { styled } from '@mui/material/styles'
import { Grid } from '@mui/material'

export const GridWrapper = styled(Grid)(({ theme }) => `
    display:flex;
    flex-direction:column;

    & .gridInnerWrapper {
        position: relative;
    }
    & .gridInnerWrapper:before {
        content: attr(data-sr);
        position: absolute;
        top:0;
        left:0;
        width:20px;
        height:20px;
        border-radius:20px;
        padding:3px;
        font-size:10px;
        background: ${theme.components.GridList.styleOverrides.borderColor};
        line-height: 15px;
        text-align: center;
        z-index: 2;
    }
`)

export const GridHeader = styled(Grid)(`
    // border:1px red solid;
    border-bottom-width:0;
`)

export const GridFooter = styled(Grid)(`
    & > div {
        display:flex;
        margin: 0;
        padding: 0;
        justify-content: flex-end;
    }
    & button {
        margin-left: 15px;
    }
`)

export const Hr = styled('hr')(({ theme }) => `
    width:calc(100% + 40px);
    margin: 10px 0 20px -20px;
    // border: 1px #E9E9E9 solid;
    border: 1px ${theme.components.GridList.styleOverrides.borderColor} solid;
`)
